
import { useState, useEffect } from "react";
import { ImageGallery } from "./ImageGallery";
import { Service } from "./types";
import { checkImageAvailability } from "@/utils/imageOptimizer";

interface ServiceImagesSectionProps {
  service: Service;
  compact?: boolean;
}

export const ServiceImagesSection = ({ service, compact = false }: ServiceImagesSectionProps) => {
  const [photoUrls, setPhotoUrls] = useState<string[]>([]);
  const [mainImageValid, setMainImageValid] = useState<boolean>(true);
  
  useEffect(() => {
    // Vérifier si l'image principale est valide
    const checkMainImage = async () => {
      if (service.photo_url) {
        const isValid = await checkImageAvailability(service.photo_url);
        setMainImageValid(isValid);
      }
    };
    
    // Extraire les URLs des photos supplémentaires
    const extractPhotos = () => {
      let photos: string[] = [];
      
      // Ajouter les photos de l'array photos
      if (Array.isArray(service.photos)) {
        photos = [...service.photos];
      }
      
      setPhotoUrls(photos);
    };
    
    checkMainImage();
    extractPhotos();
  }, [service]);
  
  return (
    <div>
      <ImageGallery 
        mainImage={mainImageValid ? service.photo_url || "" : ""}
        images={photoUrls}
        compact={compact}
      />
    </div>
  );
};
